/**
 * 大屏(bNewScreen)第 2 组英文映射（中文原文 → 英文 扁平映射）
 * 覆盖：meterReading 后半 / operation / supply / workorder / shortcutMenu
 * 通用词（确定/取消/提示/关闭/其他/退出登录 等）复用 en-US.js，此处不重复
 */
export default {
  // ---- meterReading: 抄表指标 ----
  '应抄': 'Scheduled Reading',
  '实抄': 'Actual Reading',
  '抄表率': 'Meter Reading Rate',
  '抄表率(%)': 'Meter Reading Rate (%)',
  '抄表(万户)': 'Meter Reading (10k households)',
  '水量': 'Water Volume',
  '水量(万吨)': 'Water Volume (10k tons)',
  '数量': 'Quantity',
  '数量(个)': 'Quantity (pcs)',
  '在线率': 'Online Rate',
  '在线率(%)': 'Online Rate (%)',
  '水表在线率': 'Meter Online Rate',
  '序号': 'No.',
  '表编号': 'Meter No.',
  '表类型': 'Meter Type',
  '故障类型': 'Fault Type',
  '告警时间': 'Alarm Time',
  // ---- operation: 营收/用水 ----
  '应收': 'Receivable',
  '实收': 'Actual Revenue',
  '应收总额': 'Total Receivable',
  '实收总额': 'Total Actual Revenue',
  '收缴率': 'Collection Rate',
  '金额(元)': 'Amount (CNY)',
  '元': 'CNY',
  // “万”作为数字后缀使用（值已除以 10000），如 20万 → 200K
  '万': '10K',
  '万m³': '10k m³',
  '万元': '10K CNY',
  '用水量': 'Water Consumption',
  '用水量(m³)': 'Water Consumption (m³)',
  '缴费': 'Payment',
  '缴费(元)': 'Payment (CNY)',
  '缴费金额': 'Payment Amount',
  '月度统计': 'Monthly Stats',
  '同比增长': 'YoY Growth',
  '年度营收': 'Annual Revenue',
  '本年总量': 'This Year Total',
  '本月总量': 'This Month Total',
  '上月总量': 'Last Month Total',
  '近7日总量': 'Last 7 Days Total',
  '近7日': 'Last 7 Days',
  '本月': 'This Month',
  '上月': 'Last Month',
  '年度': 'Year',
  '年度累计用水量': 'Annual Cumulative Water Consumption',
  '本月累计用水量': 'Cumulative Water Consumption This Month',
  '上月累计用水量': 'Cumulative Water Consumption of Last Month',
  '近7日累计用水量': 'Cumulative Water Consumption of Last 7 Days',
  '总用户数': 'Total Users',
  '用户总数': 'Total Users',
  '户': 'Household(s)',
  '用水类型': 'Water Use Type',
  '占比': 'Percentage',
  '加载中...': 'Loading...',
  // ---- supply: 供水/水质 ----
  '重点部位压力': 'Key Areas Pressure',
  '主管道': 'Main Pipeline',
  '支管道': 'Branch Pipeline',
  '管网名称': 'Pipe Network Name',
  '实时压力': 'Real-time Pressure',
  '实时流量': 'Real-time Flow',
  '状态': 'Status',
  '正常': 'Normal',
  '警戒': 'Warning',
  '异常': 'Abnormal',
  '未知': 'Unknown',
  '总采集点': 'Total Collection Points',
  '达标数': 'Compliant Count',
  '达标率': 'Compliance Rate',
  '异常数': 'Abnormal Count',
  '异常率': 'Abnormal Rate',
  '设备编号': 'Device No.',
  '设备名称': 'Device Name',
  '设备类型': 'Device Type',
  '当前压力值': 'Current Pressure',
  '运行状态': 'Running Status',
  '实时告警': 'Real-time Alarms',
  '年供水流量': 'Annual Water Supply Flow',
  '今日供水量': "Today's Water Supply",
  '出水压力': 'Outlet Pressure',
  '瞬时流速': 'Instantaneous Flow Rate',
  '水质指标分析': 'Water Quality Index Analysis',
  '下限': 'Lower Limit',
  '上限': 'Upper Limit',
  '色度': 'Chroma',
  '度': '°',
  '浊度': 'Turbidity',
  '硬度': 'Hardness',
  '氧化还原': 'ORP',
  '氯化物': 'Chloride',
  '温度': 'Temperature',
  '余氯': 'Residual Chlorine',
  '电导率': 'Conductivity',
  '最大值': 'Max',
  '最小值': 'Min',
  '水质合格率趋势': 'Water Quality Compliance Trend',
  '水质等级分布': 'Water Quality Grade Distribution',
  '水质合格率': 'Water Quality Compliance Rate',
  '合格率': 'Compliance Rate',
  '今日': 'Today',
  '本周': 'This Week',
  '全年': 'Full Year',
  '综合合格率': 'Overall Compliance Rate',
  'PH合格率': 'pH Compliance Rate',
  '浊度合格率': 'Turbidity Compliance Rate',
  '余氯合格率': 'Residual Chlorine Compliance Rate',
  '优': 'Excellent',
  '良': 'Good',
  '中': 'Medium',
  '差': 'Poor',
  '标准线: 95%': 'Standard Line: 95%',
  // ---- workorder: 工单 ----
  '总工单': 'Total Work Orders',
  '总工单数': 'Total Work Orders',
  '完成率': 'Completion Rate',
  '平均时长': 'Avg. Duration',
  '满意度': 'Satisfaction',
  '工单数': 'Work Orders',
  '工单数(件)': 'Work Orders (pcs)',
  '完结率(%)': 'Completion Rate (%)',
  '创建工单': 'Created Work Orders',
  '完成工单': 'Completed Work Orders',
  '平均时长(小时)': 'Avg. Duration (hours)',
  '本月工单': 'Work Orders This Month',
  '本周工单': 'Work Orders This Week',
  '昨日工单': "Yesterday's Work Orders",
  '待处理工单': 'Pending Work Orders',
  '本年工单总数': 'Total Work Orders This Year',
  '本年已完成': 'Completed This Year',
  '本年未完成': 'Unfinished This Year',
  '本年超时未完成': 'Overdue & Unfinished This Year',
  '本年工单完成率': 'Work Order Completion Rate This Year',
  '件': 'pcs',
  '总数量': 'Total',
  '换表': 'Meter Replacement',
  '工程报装': 'Engineering Installation',
  '故障报修': 'Fault Repair',
  '换表登记': 'Meter Replacement Registration',
  '旧表审核': 'Old Meter Review',
  '绑定新表': 'Bind New Meter',
  '安装': 'Install',
  '审核工单': 'Work Order Review',
  '个人新装': 'New Individual Installation',
  '报停': 'Suspension',
  '复接': 'Reconnection',
  '用水': 'Water Use',
  '企业新装': 'New Enterprise Installation',
  '销户': 'Account Cancellation',
  '用水性质变更': 'Water Use Category Change',
  '水厂报修': 'Water Plant Repair',
  '紧急': 'Urgent',
  '严重': 'Severe',
  '一般': 'Average',
  '建议': 'Suggestion',
  '小程序': 'Mini Program',
  '公众号': 'Official Account',
  '客服热线': 'Customer Service Hotline',
  'PC端': 'PC',
  '工单类型': 'Work Order Type',
  '紧急程度': 'Urgency',
  '联系人': 'Contact',
  '联系电话': 'Contact Phone',
  '申请人': 'Applicant',
  '申请时间': 'Application Time',
  '来源': 'Source',
  '已结束': 'Finished',
  '未开启': 'Not Started',
  '现场处理': 'On-site Handling',
  '审核': 'Review',
  '归档': 'Archive',
  '现场勘察': 'On-site Survey',
  '设计方案': 'Design Proposal',
  '预算': 'Budget',
  '领导审批': 'Leader Approval',
  '财务缴费': 'Financial Payment',
  '现场施工': 'On-site Construction',
  '大厅复核': 'Hall Review',
  '接单': 'Accept',
  '处理': 'Handle',
  '报装申请': 'Installation Application',
  '报装受理': 'Installation Acceptance',
  '报装勘察设计': 'Installation Survey & Design',
  '报装预算': 'Installation Budget',
  '报装审批': 'Installation Approval',
  '报装收费': 'Installation Fee Collection',
  '报装施工': 'Installation Construction',
  '报装验收': 'Installation Final Acceptance',
  '报装建档': 'Installation Filing',
  '工单来源': 'Work Order Source',
  '工单处理进度': 'Work Order Processing Progress',
  '本月工单总数': 'Total Work Orders This Month',
  '全部': 'All',
  '近七天': 'Last 7 Days',
  '近一月': 'Last Month',
  '近半年': 'Last 6 Months',
  '日': 'Day',
  '非常满意': 'Very Satisfied',
  '满意': 'Satisfied',
  '不满意': 'Dissatisfied',
  '非常不满意': 'Very Dissatisfied',
  '分': 'min',
  '条': ' records',
  '综合满意度': 'Overall Satisfaction',
  // ---- shortcutMenu ----
  '快捷键': 'Shortcuts',
  '切换全屏': 'Enter Fullscreen',
  '退出全屏': 'Exit Fullscreen',
  // ---- 通用星期/月份（图表坐标轴）----
  '周一': 'Mon',
  '周二': 'Tue',
  '周三': 'Wed',
  '周四': 'Thu',
  '周五': 'Fri',
  '周六': 'Sat',
  '周日': 'Sun',
  '1月': 'Jan',
  '2月': 'Feb',
  '3月': 'Mar',
  '4月': 'Apr',
  '5月': 'May',
  '6月': 'Jun',
  '7月': 'Jul',
  '8月': 'Aug',
  '9月': 'Sep',
  '10月': 'Oct',
  '11月': 'Nov',
  '12月': 'Dec'
}
